function padTimeComponent(component: number): string {
  return String(component).padStart(2, "0");
}

export default function formatDuration(value: number): string {
  const s = Math.floor(value) % 60;
  const m = Math.floor(value / 60) % 60;
  const h = Math.floor(value / 3600);

  if (h > 0) {
    return `${h}:${padTimeComponent(m)}:${padTimeComponent(s)}`;
  } else {
    return `${m}:${padTimeComponent(s)}`;
  }
}
